module.exports = __webpack_public_path__ + "img/27_54.14fb22a1.png";